let app_version = '1.3.5';
//let server_index = 'test';
let server_index = 'production';


export{
	app_version,
	server_index,
}